<template>
    <v-container>
        <v-row>
            <v-col :class="data.class">
                <div v-html="data.text"></div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default{
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
}
</script>